import React from 'react';
import { Alert } from 'antd';
import PropTypes from 'prop-types';
import moment from 'moment';

const dateFormat = 'DD/MM/YYYY';

function generateDesc(closeDate, closeDesc) {
  return (
    <div>
      <span>Questa copertura è stata chiusa in data <b>{moment(closeDate).format(dateFormat)}</b> con la seguente motivazione: <b>{closeDesc}</b>.
      <br/>Si prega di rendicontare solo le attività svolte fino alla data di chiusura.</span>
    </div>
  );
}

function RegistroAlert({ registryInfo }) {
  if (registryInfo && registryInfo.dataChiusuraCopertura != null) {
    return (
      <Alert 
        message="Attenzione"
        description={generateDesc(registryInfo.dataChiusuraCopertura,registryInfo.descChiusuraCopertura)}
        type="warning"
        showIcon
        className="vmg10"
      />
    );
  }
  return <div></div>;
}

RegistroAlert.propTypes = {
  registryInfo: PropTypes.object,
};

export default RegistroAlert;
